export const styles = {
  arrowColor: "white",
  backgroundColor: "white",
  overlayColor: "rgba(79, 26, 0, .2)",
  primaryColor: "#000",
  textColor: "black",
  zIndex: 1000,
}
